import { useRecordContext, useTranslate } from 'react-admin'
import { NumericFormat } from 'react-number-format'
import { makeStyles } from 'tss-react/mui'
import { CustomerTextField, LinkToRecord } from '~/components'
import { Boats, Customers } from '~/graphql/generated'
import { boatSellers, moneyEuroFormat } from '~/helpers'

const useStyles = makeStyles()((theme) => ({
  paper: {
    width: 400,
    padding: theme.spacing(2, 4, 3),
  },
}))

const CustomerPhones = ({ customer }: { customer: Customers }) => {
  return customer.phones ? (
    <span>{customer.phones.map((phone) => `, ${phone.number} (${phone.type})`)}</span>
  ) : null
}

/**
 * A boat's row in the list, opened. react-admin 5 hands an expand panel no
 * props — the boat comes from the record context. (Read from a `record` prop
 * it was undefined, and an opened row broke the whole list; which rows are
 * open is remembered, so it stayed broken after a reload.)
 */
const ExpandBoat = () => {
  const { classes } = useStyles()
  const translate = useTranslate()
  const boat = useRecordContext<Boats>()
  if (!boat) return null

  return (
    <div className={classes.paper}>
      <p>
        <b>{translate('resources.boats.fields.manufacturer')} :</b> {boat.manufacturer}
      </p>
      <p>
        <b>{translate('resources.boats.fields.model')} :</b> {boat.model}
      </p>
      <p>
        <b>{translate('resources.boats.fields.build_number')} :</b> {boat.build_number}
      </p>
      <p>
        <b>{translate('resources.boats.fields.build_year')} :</b> {boat.build_year}
      </p>

      <b>{translate('resources.customers.types.seller')} :</b>
      <ul>
        {boatSellers(boat).map((seller) => {
          return (
            <li key={seller.customer_id}>
              <LinkToRecord resource='customers' record={seller} id='customer_id'>
                <CustomerTextField source='customer.firstname' />
                <CustomerTextField source='customer.lastname' />
              </LinkToRecord>
              <CustomerPhones customer={seller.customer} />
            </li>
          )
        })}
      </ul>

      <p>
        <b>{translate('resources.boats.fields.summer_storage')} :</b> {boat.summer_storage}
      </p>
      <p>
        <b>{translate('resources.boats.fields.winter_storage')} :</b> {boat.winter_storage}
      </p>
      <p>
        <b>{translate('resources.boats.fields.asking_price')} :</b>{' '}
        <NumericFormat displayType='text' value={boat.asking_price} {...moneyEuroFormat} />
      </p>
      <p>
        <b>{translate('resources.boats.fields.lower_price_limit')} :</b>{' '}
        <NumericFormat displayType='text' value={boat.lower_price_limit} {...moneyEuroFormat} />
      </p>
    </div>
  )
}
export default ExpandBoat
